import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export const Overlay = (props = {}) => {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: 1000 }}
        open={props.show}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
